export const saveLocalStorage = (element) => {
    // Check if the list exists or not
    const data = localStorage.getItem("list");
    if(data === null){
        const listElements = [element];
        localStorage.setItem("list", JSON.stringify(listElements));
    }
    else{
        const listElements = JSON.parse(data);
        listElements.push(element);
        localStorage.setItem("list", JSON.stringify(listElements));
    }
}